import { useFormContext, useFormState, useWatch } from "react-hook-form";

import { useTheme } from "@up/data";
import {
  // HelpText,
  // InputCheckbox,
  // LabelCheckbox,
  RenderElement,
  //createRegistration,
} from "@up/form";
import { Spinner, Toast, ToastTitle } from "@up/ui";

import { FetchCatalogueItems } from "../fetch-catalogue-items";
import { Filters } from "../lib/catalogue-item-filters";

const reload = function (e) {
  e.preventDefault();
  window.location.reload();
};

export function ProgramSelection({ bottom, primaryButtonClass, supportEmail }) {
  const theme = useTheme();
  const { control, register, resetField } = useFormContext();
  const { errors } = useFormState();
  const formValues = useWatch();

  return (
    <>
      <div className="kup-rich-text">
        <p>
          <strong>Tell us which courses interest you.</strong> You'll be able to
          enroll in whichever courses are available once admitted to the
          program.
        </p>
        <p>
          For each course you select, you'll be asked to choose when you would
          like to take that course. Don't worry:{" "}
          <strong>You can change your plans once admitted.</strong>
        </p>
      </div>
      <FetchCatalogueItems>
        {({
          didError,
          isLoading,
          formData,
          filters,
          handleFilterToggle,
          resetFilters,
        }) => {
          if (isLoading) {
            return (
              <>
                <div className="mb-6 flex items-center">
                  <Spinner className="mr-3" /> Loading Programs
                </div>
                {bottom(isLoading)}
              </>
            );
          }
          if (didError) {
            return (
              <>
                <div>
                  <Toast variant="error">
                    <ToastTitle variant="error">
                      This is embarrassing
                    </ToastTitle>
                    We&apos;re having trouble loading the programs. You can try
                    again or{" "}
                    <a href={`mailto:${supportEmail}`} className="underline">
                      email support
                    </a>
                    .
                  </Toast>
                  <br />
                  <button className={primaryButtonClass} onClick={reload}>
                    Try Again
                  </button>
                  <br />
                  <br />
                </div>
                {bottom()}
              </>
            );
          }
          if (formData.length) {
            // const undecidedProps = createRegistration(
            //   register,
            //   {
            //     type: "checkbox",
            //     name: "program-selection-undecided",
            //   },
            //   formValues,
            // );

            return (
              <>
                {/* <div
                  className={`kup-program undecided relative py-2 px-1 ${
                    formValues["program-selection-undecided"]
                      ? "kup-program-selected"
                      : ""
                  }`}
                >
                  <LabelCheckbox text="I'm not sure and will make a decision later">
                    <InputCheckbox
                      value="true"
                      registerProps={{
                        ...undecidedProps,
                        onChange: async function (event) {
                          if (event.target.checked) {
                            Object.keys(formValues).forEach((key) => {
                              if (key.match(/cohort-selection-/)) {
                                resetField(key);
                              }
                              resetField("program-selection");
                            });
                          }
                          undecidedProps.onChange(event);
                        },
                      }}
                    />
                  </LabelCheckbox>
                </div>
                {formValues["program-selection-undecided"] ? (
                  <div
                    className="md:w-4/5 animation-fade-in mb-2 ml-6 pl-4 text-gray-700"
                    style={{
                      borderLeft: "4px solid rgb(231, 216, 139)",
                    }}
                  >
                    No problem. We'll process your application without a
                    specific class for now and you can choose one later.
                  </div>
                ) : null}
                <br /> */}
                <Filters
                  filters={filters}
                  handleFilterToggle={handleFilterToggle}
                />
                <div className="h-3" aria-hidden={true} />
                <fieldset>
                  <legend className="mb-2">
                    Select all courses you are interested in: *
                  </legend>
                  <RenderElement
                    control={control}
                    element={{
                      type: "program-selection",
                      name: "program-selection",
                      options: formData,
                      validate: {
                        presence: true,
                      },
                    }}
                    errors={errors}
                    formValues={formValues}
                    resetField={resetField}
                    register={register}
                  />
                </fieldset>
                {bottom()}
              </>
            );
          } else {
            return (
              <>
                <div className="mb-2">
                  <Filters
                    filters={filters}
                    handleFilterToggle={handleFilterToggle}
                  />
                </div>
                <div className="animation-fade-in">
                  <div className="pt-2 mb-2">
                    No courses match these filters
                  </div>
                  <button
                    className={`${theme.buttonPrimaryClass} w-full`}
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      resetFilters();
                    }}
                  >
                    Reset Filters
                  </button>
                </div>
              </>
            );
          }
        }}
      </FetchCatalogueItems>
    </>
  );
}
